import React from "react";
import "bootstrap/dist/css/bootstrap.css";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import "../../style/newsPage/newspage.scss";
import {
  news_subnav_content2,
  news_subnav_content1,
  news_subnav_content3,
  news_subnav_content4,
} from "../../utility/constants";

function NewsSubnav() {
  return (
    <div className="">
      <div className="news-navbar d-flex justify-content-end">
        <Navbar className="mt-4" expand="md">
          <Container fluid>
            <Nav>
              <Nav.Link href="#home" className="news-navlink-content">
                {news_subnav_content1}
              </Nav.Link>
              <Nav.Link href="#video" className="news-navlink-content">
                {news_subnav_content2}
              </Nav.Link>
              <Nav.Link href="#Publications" className="news-navlink-content">
                {news_subnav_content3}
              </Nav.Link>
              <Nav.Link href="#thoughts" className="news-navlink-content">
                {news_subnav_content4}
              </Nav.Link>
            </Nav>
          </Container>
        </Navbar>
      </div>
    </div>
  );
}

export default NewsSubnav;
